module.exports = __webpack_public_path__ + "assets/img/icon3-menu.da25e703.svg";